import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { ReactSVG } from 'react-svg'


import { useCartStore } from '@features/cart/model/useCartStore'
import { GoToCheckout } from '@features/go-to-checkout'

import { DiscountControl } from '@widgets/discount-control'

import { useZonesFromAddress } from '@shared/hooks/useZonesFromAddress'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'
import { formatGramsToHumanWeight } from '@shared/uttils/formatGramsToHumanWeight'
import getNoun from '@shared/uttils/getNoun'

import styles from './styles.module.scss'

export default function CartTotal () {
  const { t: tp } = useTranslation('product')
  const { t: tc } = useTranslation('cart')
  const { t: tco } = useTranslation('common')
  const {
    getTotalQuantity,
    cartInfoData: data,
    cartInfoLoading: loading,
  } = useCartStore()

  const {
    minOrderCost,
    isPickup,
    freeSlotDeliveryCostFrom,
    deliveryCost,
    loading: zonesLoading,
  } = useZonesFromAddress()

  const [ showDeliveryList, setShowDeliveryList ] = useState(false)

  const total = Number(data?.totals?.total ?? 0)

  return (
    <div className={styles.root}>
      <div className={cn(styles.root__row, styles.head)}>
        {data && (
          <h3 className={styles.root__title}>
            {getTotalQuantity()}{' '}
            {getNoun(
              getTotalQuantity(),
              tp('product.1'),
              tp('product.2'),
              tp('product.3'),
            )}
          </h3>
        )}

        {!!data?.totalWeight && (
          <p className={styles.root__weight}>
            ~{' '}
            {formatGramsToHumanWeight({
              weight: Number(data?.totalWeight),
              t: tco,
            })}
          </p>
        )}
      </div>

      <div className={styles.root__info}>
        <div className={styles.root__row}>
          <h4 className={styles.root__subtitle}>{tc('total.delivery')}: </h4>
          <p className={styles.root__value}>
            {formatPrice(Number(data?.delivery?.total ?? 0))}
          </p>
        </div>
      </div>

      <DiscountControl />

      <div className={styles.root__info}>
        <div className={styles.root__row}>
          <h4 className={styles.root__subtitle}>{tc('total.total')}: </h4>
          <p className={styles.root__value}>
            {formatPrice(Number(data?.totals?.total ?? 0))}
          </p>
        </div>

        {!!data?.delivery?.sale && data.delivery.sale > 0 && (
          <div className={styles.root__row}>
            <h4 className={styles.root__subtitle}>{tc('total.discount')}: </h4>
            <p className={styles.root__value}>
              {formatPrice(Number(data.delivery.sale))}
            </p>
          </div>
        )}
      </div>

      <div className={styles['root__buttons']}>
        {loading || zonesLoading ? (
          <SkeletonTheme>
            <Skeleton
              count={1}
              width="100%"
              height={56}
              style={{
                borderRadius: 12,
              }}
            />
          </SkeletonTheme>
        ) : !isPickup() ? (
          total < minOrderCost ? (
            <Button disabled size="large">
              {`${tc('order.min_limit')} ${formatPrice(minOrderCost)}. ${tc('order.missing_amount')} ${formatPrice(minOrderCost - total)}`}
            </Button>
          ) : (
            <GoToCheckout />
          )
        ) : (
          <GoToCheckout />
        )}
        {loading || zonesLoading ? (
          <SkeletonTheme>
            <Skeleton
              count={1}
              width="100%"
              height={56}
              style={{
                borderRadius: 12,
              }}
            />
          </SkeletonTheme>
        ) : !isPickup() ? (
          <div
            className={styles['root__delivery-cost']}
            onClick={() => setShowDeliveryList((prev) => !prev)}
          >
            <ReactSVG
              className={styles['root__delivery-cost__icon']}
              src="/icons/moped.svg"
              wrapper="span"
            />
            <span className={styles['root__delivery-cost__text']}>
              {/* // ? `${formatPrice(freeSlotDeliveryCostFrom - total)} до бесплатной доставки` */}
              {total < freeSlotDeliveryCostFrom
                ? tc('delivery.amount_to_free', {
                  amount: formatPrice(freeSlotDeliveryCostFrom - total),
                })
                : tc('delivery.free')}
            </span>
            <ReactSVG className={styles.control} src="/icons/arrow-right.svg" />
            {showDeliveryList && (
              <div className={styles['root__delivery-list']}>
                <p>
                  {/* Заказ от {formatPrice(minOrderCost)}:
                  <span>доставка {formatPrice(deliveryCost)}</span> */}
                  {tc('delivery.conditions.under_min', {
                    minOrderCost: formatPrice(minOrderCost),
                    deliveryCost: formatPrice(deliveryCost),
                  })}
                </p>
                <p>
                  {/* Заказ от {formatPrice(freeSlotDeliveryCostFrom)}:{" "}
                  <span>доставка бесплатная</span> */}
                  {tc('delivery.conditions.over_free', {
                    freeSlotDeliveryCostFrom: formatPrice(
                      freeSlotDeliveryCostFrom,
                    ),
                  })}
                </p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}
